(function ($) {
    $(function () {
        // Start Cart Js
        var getUrlParameter = function getUrlParameter(sParam) {
            var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split("&"),
            sParameterName,
            i;
            for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split("=");
            if (sParameterName[0] === sParam) {
                return typeof sParameterName[1] === undefined
                ? true
                : decodeURIComponent(sParameterName[1]);
            }
            }
            return false;
        };
        var cart = getUrlParameter("cartr");
        if (cart == "y") {
            $("body").toggleClass("cartShown");
            $('.cart-close').click(function () {
                $("body").removeClass("cartShown");
            });
        }

        var header = new Headroom(document.querySelector('header'), {
            tolarence: 80,
            offset: 55,
            classes: {

                initial: 'headroom',
                pinned: 'slidedown',
                unpinned: 'slideup',
                top: "headroom--top",
                notTop: "headroom--not-top",
                bottom: "headroom--bottom",
                notBottom: "headroom--not-bottom",
                frozen: "headroom--frozen",

            }
        });
        header.init();


        // Phone nav click function
        $('.hamburger').click(function () {
            $("body").toggleClass("navShown");
            $(".nav-wrap").fadeToggle()
            $('.nav-close').click(function () {
                $("body").removeClass("navShown");
                $(".nav-wrap").fadeOut()
            });
        });

        $('.cart-icon a, .cart-btn a').click(function (e) {
            e.preventDefault()
            $("body").toggleClass("cartShown");

            $('.cart-close').click(function () {
                $("body").removeClass("cartShown");
            });
        });

        $('.cart-wrap').click(function () {
            $("body").removeClass("cartShown");
        });
        $('.main-cart-wrap').click(function (e) {
            e.stopPropagation();
        });


        if ($('.marquee-slider').length) {
            $('.marquee-slider').marquee({
                direction: 'left',
                duration: 20000,
                gap: 0,
                delayBeforeStart: 0,
                duplicated: true,
                startVisible: true
            });
        }


        // Giving Back page
        if ($('.instagram-item-wrap').length) {
            $('.instagram-item-wrap').slick({
                autoplay: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: true,
                responsive: [
                    {

                        breakpoint: 769,
                        settings: {
                            slidesToShow: 1,
                        }
                    }
                ]
            })

            $(window).on('resize', function () {
                $('.instagram-item-wrap').slick('resize');
            });
        }

        if ($('.review-item-wrap').length) {
            $('.review-item-wrap').slick({
                autoplay: false,
                slidesToShow: 1,
                slidesToScroll: 1,
                mobileFirst: true,
                arrows: false,
                dots: false,
                infinite: true,
                variableWidth: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: 'unslick'
                    }
                ]
            })

            $(window).on('resize', function () {
                $('.review-item-wrap').slick('resize');
            });
        }


        // Start shop page
        $('.shop-single-tab-trigger ul li').click(function () {
            $('.shop-single-tab-trigger ul li').removeClass('active');
            $(this).addClass('active');
            $('.shop-single-tab-item').hide();
            var activeTab = $(this).find('a').attr('href');
            $(activeTab).fadeIn();
            return false;
        });

        var headerHeight = $('.main-header-section').outerHeight()
        
        
        function scrollNav() {
            $('.index-page-url').click(function () {
                $('body').removeClass('navShown')
                if ($(window).width() < 769) {
                    $('.nav-wrap').fadeOut();
                }
                // $('html, body').stop().animate({
                //     scrollTop: $($(this).attr('href')).offset().top - headerHeight
                // }, 500);
                // return false;
            });
        }
        scrollNav();

        $('a[href^="#"]').click(function() {
            var gotoSec = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(gotoSec).offset().top
            }, 500);
        });
        
        
        
        
        
        
        
        
        
        /*$(".main-nav ul li a").on('click', function (event) {
            // Prevent default anchor click behavior
            event.preventDefault();

            $('body').removeClass('navShown')
            if ($(window).width() < 768){
                $('.nav-wrap').fadeOut();
            }
            
            // Store hash
            var hash = this.hash;
            var ofTop = $(hash).offset().top - 100
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            
            $('html, body').animate({
                scrollTop:  ofTop
            }, 1000, function () {

                window.location.hash = hash;
                // Add hash (#) to URL when done scrolling (default click behavior)
            });
        });*/
        
        /*$('.main-nav ul li a').click(function (e) {
            e.preventDefault();
            $('body').removeClass('navShown')
            if ($(window).width() < 768){
                $('.nav-wrap').fadeOut();
            }
                var target = $($(this).attr('href'));
            if (target.length) {
                var scrollTo = target.offset().top - headerHeight;
                $('body, html').animate({
                    scrollTop: scrollTo + 'px'
                }, 800);
            }
        });*/

        $(window).scroll(function () {

            // The varriables
            var $titleDiv = $('.hero-inner');


            //Get scroll position of window
            var windowScroll = $(this).scrollTop();

            if ($(window).width() < 768) {
                //Slow scroll of social div and fade it out
                $titleDiv.css({
                    'margin-top': -(windowScroll / 10) + "px",
                    'opacity': 1 - (windowScroll / 550)
                });
            }

            if ($(window).width() > 767) {
                $titleDiv.css({
                    'margin-top': -(windowScroll / 5) + "px",
                    'opacity': 1 - (windowScroll / 550)
                });
            }
            $titleDiv.css({
                'opacity': 1 - (windowScroll / 400)
            });
        });



        
        
        
        var $anim_elem = $('.anim-parallax');
        var $$window = $(window);
        
        
        function parallax_rotate() {
            var windowHeight = $$window.height();
            var windowTopPosition = $$window.scrollTop();
            var windowBottomPosition = (windowTopPosition + windowHeight)
            $.each($anim_elem, function(){
                var $elem = $(this);
                var elemTopPosition = $(this).offset().top;
                var elemMoveSet = windowTopPosition - elemTopPosition ;
                console.log(elemMoveSet)
                var elemMove = elemMoveSet / 8;
                if (elemTopPosition <= windowBottomPosition) {
                    $elem.css("transform", `translateY(${-elemMove}px) rotate(${-(elemMove *3)}deg) `)
                    $anim_elem.eq(0).css("transform", `translateY(${-elemMove}px) rotate(${-(elemMove *3)}deg) `)
                    $anim_elem.eq(1).css("transform", `translateY(${-elemMove}px) rotate(${(elemMove * 3)}deg) `)
                    $anim_elem.eq(2).css("transform", `translateY(${-elemMove}px) rotate(${-(elemMove * 3)}deg) `)
                }
            })
        }
        
        $$window.on('scroll resize', parallax_rotate);
        $$window.trigger('scroll');

        if ($('.prepear-details-logo').length) {
            $(function () {
                var el = $('.prepear-details-logo');
                var index = 0;
                var timer = window.setInterval(function () {
                    if (index < el.length) {
                        el.eq(index++).addClass('popup-added');
                    } else {
                        window.clearInterval(timer);
                    }
                }, 700);
            });
            
        }
        

        var $animation_elements = $('.anim');
        var $window = $(window);

        function check_if_in_view() {
            var window_height = $window.height() / 1.3;
            var window_top_position = $window.scrollTop();
            var window_bottom_position = (window_top_position + window_height);
            $.each($animation_elements, function () {
                var $element = $(this);
                var element_top_position = $element.offset().top;
                if (element_top_position <= window_bottom_position) {
                    $element.addClass('in-view');
                } else {}
            });
        }
        $window.on('scroll resize', check_if_in_view);
        $window.trigger('scroll');



        if ($('.split-heading').length) {
            var res = Splitting({
                target: '.split-heading',
                by: 'lines',
            });

            Splitting();

            res.forEach((splitResult) => {
                const wrappedLines = splitResult.lines.map((wordsArr) => `
            <span class="line"><span class="mask-up">
            ${wordsArr.map((word) => `${word.outerHTML}<span class="whitespace">
            </span>`).join('')}
            </span></span>`).join('');
                splitResult.el.innerHTML = wrappedLines;
            });
            inView.threshold(0.75);
            inView(".split-heading").on("enter", function (el) {
                if (!el.classList.contains("has-animated")) {
                    anime({
                        targets: el.querySelectorAll(".mask-up"),
                        translateY: ["100%", "0%"],
                        duration: 700,
                        delay: anime.stagger(200),
                        easing: "easeOutQuad",
                        autoplay: true
                    });
                    el.classList.add("has-animated");
                }
            });
        }

    }) // End ready function.


    var $animation_elements = $('.animate-view');
    var $window = $(window);

    function check_if_in_view() {
        var window_height = $window.height();
        var window_top_position = $window.scrollTop();
        var window_bottom_position = (window_top_position + window_height);
        $.each($animation_elements, function () {
            var $element = $(this);
            var element_height = $element.outerHeight();
            var element_top_position = $element.offset().top;
            var element_bottom_position = (element_top_position + element_height);
            if (element_top_position <= window_bottom_position) {
                $element.addClass('in-view');
            } else {}
        });
    }
    $window.on('scroll resize', check_if_in_view);
    $window.trigger('scroll');


})(jQuery)

var mac = 0;
if (navigator.userAgent.indexOf('Mac') > 0) {
    mac = 1;
} else {
    mac = 0;
}
if (1 == mac) {
    $('body').addClass('mac-os');
} else {
    $("body").addClass('win-os');
}



function closeCart(e,el){
    e.preventDefault();
    $("body").removeClass("cartShown");
}

$(document).on("click",".overlay",function(e) {
    $("body").removeClass("cartShown");
});



$( ".single-product__atc").on("click", function (e) {
    e.preventDefault();
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $('.single-product-form').serialize(),
          success: function(data) {
             get_cart_details();
            $('body').addClass('cartShown');
          },
          error: 'addToCartFail'
      });
      
  });


  function get_cart_details(){
    fetch("?section_id=cart-drawer")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);
        var cart_items = $(".cart-wrap", cart_html);
        $(".cart-wrap").replaceWith(cart_items);

      });
  
      fetch("?section_id=header")
      .then((response) => response.text())
      .then((cartData) => {
        var cart_html = $(cartData);

        var cart_count = $(".cart-icon dfn", cart_html);
        $(".cart-icon dfn").replaceWith(cart_count);

      });
      
  
  };


  function change_qty($input){
    var variant_id= $($input).attr("data-id");
    var quantity= $($input).val();          
    var data = { updates: {} };
    data.updates[variant_id] = quantity;
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {               
        get_cart_details();
      }
    });
  };


  function increaseItem(e, el) {
    var $input = el.previousElementSibling;
    var value = parseInt($input.value, 10);
    value = isNaN(value) ? 0 : value;
    value++;
    $input.value = ('0' + value).slice(-2);            
    change_qty($input);
  }
  
  function decreaseItem(e, el) {
    var $input = el.nextElementSibling;
    var value = parseInt($input.value, 10);
    if (value > 1) {
        value = isNaN(value) ? 0 : value;
        value--;
        $input.value = ('0' + value).slice(-2);         
        change_qty($input);
    }
  }


    //   Remove
    function itemRemove(e , el){
        e.preventDefault();
        var variant_id = $(el).attr('data-id');
        console.log(variant_id);
        var data = { updates: {} };
        data.updates[variant_id] = '0';
        jQuery.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: data,
          dataType: 'json',
          success: function(res) {
            get_cart_details();
          }
        });
            //  $(el).parent().parent().remove();
      }




      let userSelectValues = [];
      let currentContainerProductObject = {};
    
      [...document.querySelectorAll(".shop-single-guide-row-wrap input")].map(item => {
          item.addEventListener("change", (e) => {
              userSelectValues = [];
    
    
                [...document.querySelectorAll('.shop-single-guide-row-wrap input')].map(i => {
                  
                  if(i.checked == true){
                      userSelectValues.push(i.value);
                  }
              });
    
              let matchedVariants = mainProduct.variants.find(variant => {
                  let match = true;
                        
                  for (let i = 0; i < userSelectValues.length; i++) {
                      if (userSelectValues.indexOf(variant.options[i]) == -1) {
                          match = false;
                          break;
                      }
                  }
                  
                  return match;
              });
    
            //    console.log("matchedVariants: ", matchedVariants.id);
            document.querySelector('.single-product-form input[name="id"]').value = matchedVariants.id;
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?variant=' + matchedVariants.id;
                window.history.replaceState({path:newurl}, document.title, newurl);

              
          })
      })
    



      var target =  window.location.search;
       

    var match_id = target.replace('?variant=','');


    $( ".shop-single-guide-row-wrap input" ).each(function( index ) {
        $('.shop-single-guide-row-wrap input').removeAttr("checked");
        if($( this ).data('id') == match_id){
            $(this).prop("checked", true);
        }else{
            $('.shop-single-guide-row-wrap input').removeAttr("checked");
        }
   
      });